var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import Pagination from '../../common/components/Pagination';
import ReportStockService from '../../api/ReportStockService';
import CommonService from '../../api/CommonService';
import GlobalVue from '../../globalVue';
import { Loading } from 'element-ui';
import { UrlHelper } from '../../helper/UrlWrapper';
import QueryDetailList from './QueryDetailList.vue';
import { auth } from '../../helper/authDecorator';
import { nameDict } from '../../constant/authCode';
import TableList from '../../components/common/TableList.vue';
function getDefaultFormData() {
    var data = {
        depot_ids: [],
        keyword: '',
        goods_format_id: null,
        show_stock_goods: '1',
        goods_type_id: null,
    };
    return data;
}
function tidyDepotList(treeData) {
    treeData.forEach(function (item) {
        if (item.organ_id && !item.depot_id) {
            item.depot_id = 'organ_id_' + item.organ_id;
            item.depot_name = item.organ_name;
        }
        if (item.children && item.children.length) {
            tidyDepotList(item.children);
        }
    });
}
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.TabMenuPowerId = 134;
        _this.service = ReportStockService.getInstance();
        _this.fetchAction = _this.service.getStockList;
        _this.tableHeight = document.documentElement.clientHeight - 275;
        _this.filter = {};
        _this.filterColumns = [];
        _this.dataActions = [];
        _this.formData = getDefaultFormData();
        _this.depotList = [];
        _this.categoryData = [];
        _this.stockData = {};
        _this.detailData = [];
        _this.detailTotal = 0;
        _this.stockDetailVisbile = false;
        _this.stockDetailData = {};
        return _this;
    }
    List.prototype.normalizerDepot = function (id, name) {
        if (id === void 0) { id = 'id'; }
        if (name === void 0) { name = 'name'; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    List.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    List.prototype.created = function () {
        var _this = this;
        this.commonService = CommonService.getInstance();
        if (!this.Root_PageAuth.WarningManage)
            this.filterColumns = ['expire_remaining_stock', 'will_expire_remaining_stock', 'warn_unsalable_day', 'unsalable_day'];
        this.initFilter(this.filter);
        this.getAuth('210002').then(function (pageAuth) {
            if (!!pageAuth) {
                _this.dataActions = [
                    {
                        name: '明细',
                        click: _this.lookDetail
                    }
                ];
            }
        });
    };
    List.prototype.mounted = function () {
        this.getOrganDepot();
        this.getCategory();
    };
    List.prototype.fetchCallBack = function (data) {
        this.stockData = data;
    };
    List.prototype.initFilter = function (filter) {
        this.filter = {
            depot_ids: (this.formData.depot_ids || []).join(','),
            keyword: this.formData.keyword,
            show_stock_goods: this.formData.show_stock_goods,
            goods_type_id: this.formData.goods_type_id ? this.formData.goods_type_id : -1,
        };
    };
    List.prototype.showStockDetail = function (item) {
        var _this = this;
        this.stockDetailData = { depot_id: item.depot_id, goods_format_id: item.goods_format_id };
        this.detailData = [];
        this.stockDetailVisbile = true;
        this.$nextTick(function () {
            _this.$refs.detailPagination.clear();
            _this.getStockDetailList();
        });
    };
    List.prototype.detailPageChange = function (pager) {
        this.getStockDetailList();
    };
    List.prototype.getStockDetailList = function () {
        var _this = this;
        var pager = this.$refs.detailPagination.getPage();
        var params = Object.assign(this.stockDetailData, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getStockDetail(params)
            .then(function (res) {
            loadingInstance.close();
            _this.detailData = res.data.data;
            _this.detailTotal = res.data.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    List.prototype.getOrganDepot = function () {
        var _this = this;
        var params = { is_init: 1 };
        this.commonService
            .getOrganDepot(params)
            .then(function (res) {
            _this.depotList = [];
            if (res.data.data.length) {
                var data = res.data.data;
                tidyDepotList(data);
                _this.depotList = data;
            }
        })
            .catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    List.prototype.getCategory = function () {
        var _this = this;
        this.service
            .getCategory()
            .then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    List.prototype.searchClick = function () {
        var _this = this;
        this.initFilter(this.filter);
        this.$nextTick(function () {
            _this.$refs.TableList.fetch();
        });
    };
    List.prototype.reset = function () {
        this.formData = getDefaultFormData();
    };
    List.prototype.lookDetail = function (row) {
        GlobalVue.$emit('addTab', {
            component: QueryDetailList,
            title: '出入库明细',
            showExist: false,
            name: 'query-detail-list',
            cprops: {
                depot_ids: row.depot_id ? [row.depot_id] : [],
                goods_code: row.goods_code || '',
                goods_format_id: row.goods_format_id || null,
                keyword: row.goods_name,
            },
        });
    };
    List.prototype.exportData = function () {
        var url = 'supplierclientapi/report/export_stock_list?';
        url = UrlHelper.addParam(url, 'depot_ids', (this.formData.depot_ids || []).join(','));
        url = UrlHelper.addParam(url, 'keyword', this.formData.keyword);
        url = UrlHelper.addParam(url, 'show_stock_goods', this.formData.show_stock_goods);
        url = UrlHelper.addParam(url, 'goods_type_id', this.formData.goods_type_id ? this.formData.goods_type_id : -1);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(['_trackEvent', '库存查询列表', '库存查询导出']);
    };
    List = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            methods: __assign({}, mapActions(["getAuth"])),
            components: {
                pagination: Pagination,
                TableList: TableList
            },
        }),
        auth(nameDict["库存查询"], true)
    ], List);
    return List;
}(Vue));
export default List;
